import {getCheckoutOrderManager} from 'cart-ui';
import * as facebookAnalytics from 'facebook-analytics';
import * as googleAnalytics from 'google-analytics';
import ECommerceEnhanced from './ECommerceEnhanced';

export default function init() {
    googleAnalytics.init();
    facebookAnalytics.init();

    if (window.rcmGoogleAnalyticsConfig !== undefined) {
        // Google analytics config doesn't exist in some places like on the stand-alone order calculator app
        window.rcmGoogleAnalyticsConfig.onAccessDenied = function () {
            location.href = '/login?redirect=' + encodeURIComponent(location.pathname);
        };
    }

    getCheckoutOrderManager().then((orderMgr) => {
        // tslint:disable-next-line:no-unused-expression
        new ECommerceEnhanced(googleAnalytics.gtag, orderMgr);
    });
}
